import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索你的「第一次」
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            选择你感兴趣的场景，获取量身定制的准备攻略
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => {
            const colorMap: Record<string, { bg: string; text: string; hover: string }> = {
              primary: { bg: "bg-primary-100", text: "text-primary-700", hover: "hover:bg-primary-200/70" },
              accent: { bg: "bg-accent-100", text: "text-accent-700", hover: "hover:bg-accent-200/70" },
              secondary: { bg: "bg-secondary-100", text: "text-secondary-700", hover: "hover:bg-secondary-200/70" },
            };
            const c = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center p-6 rounded-xl ${c.bg} ${c.hover} transition-all duration-300 cursor-pointer border border-transparent hover:border-background-300/60`}
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50 mb-3 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${cat.icon} text-xl ${c.text}`}></i>
                </div>
                <span className={`text-sm font-medium ${c.text} whitespace-nowrap text-center`}>
                  {cat.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}